<template>
  <div class="container-fluid px-0">
    <div class="row mt-4 border-radius-border-12">
      <div class="col-md-12 col-12 px-0 text-center">
        <div
          class="row tabl border-0 report d-flex justify-content-between p-2 p-md-4"
        >
          <div class="col-md-5 pl-0 pr-4 col-12">
            <h4 class="ju header4" style="color: #292929">
              Financial Statements
            </h4>
            <p class="ju paragraph1 text-black fw-300">
              Understand your church's financial health. Use these key
              statements for a clear picture of your ministry's financial
              standing
            </p>
          </div>
          <!-- border-bottom -->
          <div class="col-md-7 col-12 cursor-pointer">
            <div
              class="row d-md-flex justify-content-md-between d-flex justify-content-between"
            >
              <router-link to="/tenant/reports/incomestatement" class="linked">
                <h4
                  class="ju header4 d-md-flex s-20 justify-content-md-start"
                  style="color: #0040ff"
                >
                Profit & Loss (Income Statement) 
                </h4>
              </router-link>
              <router-link to="/tenant/reports/incomestatement" class="linked">
                <span
                  ><el-icon :color="primarycolor" :size="18"
                    ><ArrowRight /></el-icon
                ></span>
              </router-link>
              <!-- <router-link
                to="/tenant/reports/incomestatementreport"
                class="linked"
              >
                <h4
                  class="ju header4 d-md-flex s-20 justify-content-md-start"
                  style="color: #0b55d4"
                >
                  Income Statement
                </h4>
              </router-link>
              <router-link
                to="/tenant/reports/incomestatementreport"
                class="linked"
              >
                <span
                  ><el-icon :color="primarycolor" :size="18"
                    ><ArrowRightBold /></el-icon
                ></span>
              </router-link> -->
            </div>
            <div class="row">
              <p class="ju mb-3 paragraph1">
                A summary of your church's income and expenses over a defined
                period, showing your net balance.
              </p>
            </div>
            <div class="row">
              <hr class="w-100" />
            </div>
          </div>

          <div class="col-md-5 px-0 col-12"></div>
          <div class="col-md-7 col-12 mt-2">
            <div
              class="row d-md-flex justify-content-md-between d-flex justify-content-between"
            >
              <router-link
                to="/tenant/reports/incomestatementfund"
                class="linked"
              >
                <h4
                  class="ju header4 d-md-flex s-20 justify-content-md-start"
                  style="color: #0040ff"
                >
                Profit & Loss (Income Statement By Fund)
                </h4>
              </router-link>
              <router-link
                to="/tenant/reports/incomestatementfund"
                class="linked"
              >
                <span
                  ><el-icon :color="primarycolor" :size="18"
                    ><ArrowRight /></el-icon
                ></span>
              </router-link>
            </div>
            <div class="row">
              <p class="ju mb-3 paragraph1">
                A summary of your church's income and expenses over a defined
                period grouped into funds, showing your net balances by each
                fund.
              </p>
            </div>
            <div class="row">
              <hr class="w-100" />
            </div>
          </div>
          <div class="col-md-5 px-0 col-12"></div>
          <div class="col-md-7 col-12 mt-2">
            <div
              class="row d-md-flex justify-content-md-between d-flex justify-content-between"
            >
              <router-link to="/tenant/reports/inflowreport" class="linked">
                <h4
                  class="ju header4 d-md-flex s-20 justify-content-md-start"
                  style="color: #0040ff"
                >
                  Inflow or Income
                </h4>
              </router-link>
              <router-link to="/tenant/reports/inflowreport" class="linked">
                <span
                  ><el-icon :color="primarycolor" :size="18"
                    ><ArrowRight /></el-icon
                ></span>
              </router-link>
            </div>
            <div class="row">
              <p class="ju mb-3 paragraph1">
                This report provides a comprehensive view of all funds received
                by the church. It lists each source of income, such as tithes,
                offerings, designated gifts, fundraising proceeds, and other
                income streams.
              </p>
            </div>
            <div class="row">
              <hr class="w-100" />
            </div>
          </div>

          <div class="col-md-5 px-0 col-12"></div>
          <div class="col-md-7 col-12 mt-2">
            <div
              class="row d-md-flex justify-content-md-between d-flex justify-content-between"
            >
              <router-link to="/tenant/reports/outflowreport" class="linked">
                <h4
                  class="ju header4 d-md-flex s-20 justify-content-md-start"
                  style="color: #0040ff"
                >
                  Outflow or Expense
                </h4>
              </router-link>
              <router-link to="/tenant/reports/outflowreport">
                <span
                  ><el-icon :color="primarycolor" :size="18"
                    ><ArrowRight /></el-icon></span
              ></router-link>
              <!-- <router-link to="/tenant/reports/expensereport" class="linked">
                <h4
                  class="ju header4 d-md-flex s-20 justify-content-md-start"
                  style="color: #0040ff"
                >
                  Outflow or Expense Report
                </h4>
              </router-link>
              <router-link to="/tenant/reports/expensereport">
                <span
                  ><el-icon :color="primarycolor" :size="18"
                    ><ArrowRight /></el-icon></span
              ></router-link> -->
            </div>
            <div class="row">
              <p class="ju mb-3 paragraph1">
                This report provides a comprehensive view of all expenses
                incurred by the church. It lists each expenditure, categorized
                by expense accounts such as ministry expenses, salaries,
                utilities, and facility maintenance
              </p>
            </div>
            <div class="row">
              <hr class="w-100" />
            </div>
          </div>
          <div class="col-md-5 px-0 col-12"></div>
          <div class="col-md-7 col-12 mt-2">
            <div
              class="row d-md-flex justify-content-md-between d-flex justify-content-between"
            >
              <router-link to="/tenant/reports/cashflow" class="linked">
                <h4
                  class="ju header4 d-md-flex s-20 justify-content-md-start"
                  style="color: #0040ff"
                >
                  Cash Flow
                </h4>
              </router-link>
              <router-link to="/tenant/reports/cashflow">
                <span
                  ><el-icon :color="primarycolor" :size="18"
                    ><ArrowRight /></el-icon></span
              ></router-link>
            </div>
            <div class="row">
              <p class="ju mb-3 paragraph1">
                This report tracks the actual cash coming into the church (e.g.,
                offerings) and the cash going out (e.g., expenses). It helps you
                understand if your church has enough cash on hand to cover its
                bills and upcoming expenses.
              </p>
            </div>
            <div class="row">
              <hr class="w-100" />
            </div>
          </div>
          <div class="col-md-5 px-0 col-12"></div>
          <div class="col-md-7 col-12 mt-2">
            <div
              class="row d-md-flex justify-content-md-between d-flex justify-content-between"
            >
              <router-link to="/tenant/reports/balancesheet" class="linked">
                <h4
                  class="ju header4 d-md-flex s-20 justify-content-md-start"
                  style="color: #0040ff"
                >
                  Balance Sheet
                </h4>
              </router-link>
              <router-link to="/tenant/reports/balancesheet">
                <span
                  ><el-icon :color="primarycolor" :size="18"
                    ><ArrowRight /></el-icon></span
              ></router-link>
            </div>
            <div class="row">
              <p class="ju mb-3 paragraph1">
                This report provides a snapshot of your church's financial
                standing at a specific date. It lists your assets (cash,
                property, investments), liabilities (loans, accounts payable),
                and net assets (the church's equity or fund balance).
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--border 2-->
    <div class="row mt-5 border-radius-border-12">
      <div class="col-md-12 col-12 px-0 text-center">
        <div
          class="row tabl border-0 report d-flex justify-content-between p-2 p-md-4"
        >
          <div class="col-md-5 pl-0 pr-4 col-12">
            <h4 class="ju header4" style="color: #292929">Contributions</h4>
            <p class="ju paragraph1 text-black fw-300">
              See an overview of how contributions are made in your ministry
            </p>
          </div>
          <div class="col-md-7 col-12">
            <router-link :to="{ name: 'OfferingFinancialReport' }">
              <div
                class="row d-md-flex justify-content-md-between d-flex justify-content-between"
              >
                <h4
                  class="ju header4 d-md-flex s-20 justify-content-md-start"
                  style="color: #0040ff"
                >
                  Offering & Contribution Report
                </h4>
                <span
                  ><el-icon :color="primarycolor" :size="18"
                    ><ArrowRight /></el-icon
                ></span>
              </div>
            </router-link>
            <div class="row">
              <p class="ju mb-3 paragraph1">
                Snapshot of contribution(offering) made to your church
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5 border-radius-border-12">
      <div class="col-md-12 col-12 px-0 text-center">
        <div
          class="row tabl border-0 report d-flex justify-content-between p-2 p-md-4"
        >
          <div class="col-md-5 pl-0 pr-4 col-12">
            <h4 class="ju header4" style="color: #292929">
              Pledges & Partnership
            </h4>
            <p class="ju paragraph1 text-black fw-300">
              See an overview of how pledges are made in your ministry
            </p>
          </div>
          <div class="col-md-7 col-12">
            <router-link :to="{ name: 'FinancialPledgesReport' }">
              <div
                class="row d-md-flex justify-content-md-between d-flex justify-content-between"
              >
                <h4
                  class="ju header4 d-md-flex s-20 justify-content-md-start"
                  style="color: #0040ff"
                >
                  Pledges/Partnership Report
                </h4>
                <span
                  ><el-icon :color="primarycolor" :size="18"
                    ><ArrowRight /></el-icon
                ></span>
              </div>
            </router-link>
            <div class="row">
              <p class="ju mb-3 paragraph1">
                Snapshot of pledges/partnership made to your church
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--border 2-->
    <!--border 3-->
    <div class="row mt-5 mb-5 border-radius-border-12">
      <div class="col-md-12 col-12 px-0 text-center">
        <div
          class="row tabl border-0 report d-flex justify-content-between p-2 p-md-4"
        >
          <div class="col-md-5 pl-0 pr-4 col-12">
            <h4 class="ju header4" style="color: #292929">Transactions</h4>
            <p class="ju paragraph1 text-black fw-300">
              See an overflow of transactions performed in your church
            </p>
          </div>
          <div class="col-md-7 col-12 mt-2">
            <div
              class="row d-md-flex justify-content-md-between d-flex justify-content-between"
            >
              <router-link
                to="/tenant/reports/financialactivitiesbalance"
                class="linked"
              >
                <h4
                  class="ju header4 d-md-flex s-20 justify-content-md-start"
                  style="color: #0040ff"
                >
                  Account Balancing
                </h4>
              </router-link>
              <router-link to="/tenant/reports/financialactivitiesbalance">
                <span
                  ><el-icon :color="primarycolor" :size="18"
                    ><ArrowRight /></el-icon
                ></span>
              </router-link>
            </div>
            <div class="row">
              <p class="ju mb-3 paragraph1">
                Snapshot of account activities and balance.
              </p>
            </div>
          </div>
          <div class="col-md-5 px-0 col-12"></div>
          <div class="col-md-7 col-12">
            <div
              class="row d-md-flex justify-content-md-between d-flex justify-content-between"
            >
              <router-link to="/tenant/reports/trialbalance" class="linked">
                <h4
                  class="ju header4 d-md-flex s-20 justify-content-md-start"
                  style="color: #0040ff"
                >
                  Trial Balance
                </h4></router-link
              >
              <router-link to="/tenant/reports/trialbalance">
                <span
                  ><el-icon :color="primarycolor" :size="18"
                    ><ArrowRight /></el-icon></span
              ></router-link>
            </div>
            <div class="row">
              <p class="ju mb-3 paragraph1">Snapshot of Trial Balance</p>
            </div>
            <div class="row">
              <hr class="w-100" />
            </div>
          </div>
          <div class="col-md-5 px-0 col-12"></div>
          <div class="col-md-7 col-12">
            <div
              class="row d-md-flex justify-content-md-between d-flex justify-content-between"
            >
              <router-link
                to="/tenant/reports/accountingtransactionreport"
                class="linked"
              >
                <h4
                  class="ju header4 d-md-flex s-20 justify-content-md-start"
                  style="color: #0040ff"
                >
                  Account Transactions
                </h4></router-link
              >
              <router-link to="/tenant/reports/accountingtransactionreport">
                <span
                  ><el-icon :color="primarycolor" :size="18"
                    ><ArrowRight /></el-icon></span
              ></router-link>
            </div>
            <div class="row">
              <p class="ju mb-3 paragraph1">
                Snapshot of account transactions. and what you
              </p>
            </div>
            <div class="row">
              <hr class="w-100" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--border 3-->
  </div>
</template>

<script>
import { inject } from "vue";
export default {
  setup() {
    const primarycolor = inject("primarycolor");

    return {
      primarycolor,
    };
  },
};
</script>

<style scoped>
.report {
  width: 100%;
  margin: auto;
}
.ju {
  text-align: start;
}
.header4 {
  font-size: 24px;
  font-weight: 500;
}
.paragraph1 {
  font-size: 14px;
  font-weight: 400;
  /* line-height: 27px; */
  color: #787878;
  /* background-color: #fff; */
}
.rounded {
  border-color: #b0b2b5 !important;
  border-radius: 15px !important;
}
.linked {
  text-decoration: none !important;
}
.linked:hover {
  text-decoration: underline !important;
}
</style>
